// extracted by mini-css-extract-plugin
export default {"container":"ChangeMonitoringConsistencyCheckMenu_container__V91R7"};